import { render, staticRenderFns } from "./techMy.vue?vue&type=template&id=42c681ae&scoped=true"
import script from "./techMy.vue?vue&type=script&lang=js"
export * from "./techMy.vue?vue&type=script&lang=js"
import style0 from "./techMy.vue?vue&type=style&index=0&id=42c681ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c681ae",
  null
  
)

export default component.exports